import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useState } from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Home({ validChain }) {

  {/* User Hover Text controls */}
  const [hoveredUser, setHoveredUser] = useState(false);
  const toggleHoverUser = () => setHoveredUser(!hoveredUser);
  const [hoveredPrvdr, setHoveredPrvdr] = useState(false);
  const toggleHoverPrvdr = () => setHoveredPrvdr(!hoveredPrvdr);
  const [hoveredEvntOwn, setHoveredEvntOwn] = useState(false);
  const toggleHoverEvntOwn = () => setHoveredEvntOwn(!hoveredEvntOwn);
  const [hoveredLearn, setHoveredLearn] = useState(false);
  const toggleHoverLearn = () => setHoveredLearn(!hoveredLearn);
  {/* End User Hover Text Controls */}
  
  const [cookies, setCookie] = useCookies();

  function loginUser() {
    console.log("Logging in as user");
    setCookie('userType', "user", { path: '/' });

  }
  
  function loginProvider() {
    console.log("Logging in as provider");
    setCookie('userType', "provider", { path: '/' });
    
  }
  
  function loginEventOwner() {
    console.log("Logging in as event owner");
    setCookie('userType', "eventowner", { path: '/' });
    
  }

  return (
    <>
      <Navbar validChain={validChain} />

      <div className="dapp2sect wf-section">
        <div data-w-id="95938c20-8018-9302-4ba9-3884986a1767" className="dappcont">
          <p className="paragraph-3"><span className="hdrSection"> Welcome to the $BioFi Utility Ecosystem!</span><br />Thank you for being part of our success and community. <br /> <strong>Notice: Make sure you have cookies enabled or you may experience connection problems.</strong> <br />Please sign in to your wallet then choose one of the options below. <br /> For more information about supported wallets, click here: <a href="https://info.biometricfinancial.org/faq/" className="link-4" target="_blank" rel="noreferrer">FAQ</a>
          </p>
          {/*User Secton Start*/}
          <div className="dappcont1">
            <div className="w-layout-grid grid">

              <Link to="/login" onClick={loginUser} className="dappbtn1 w-inline-block" onMouseEnter={toggleHoverUser} onMouseLeave={toggleHoverUser}>
                <div className="material_icon2">person</div>
                <div className="text-block">User</div>
                {hoveredUser && <div className="userLogin1">Click here if you are an individual consumer who wants to gain access to the BioFi Ecosystem.</div>}
              </Link>
              {/*User Section End*/}

              {/*Provider Section Start*/}
              <Link to="/login" onClick={loginProvider} className="dappbtn1 w-inline-block" onMouseEnter={toggleHoverPrvdr} onMouseLeave={toggleHoverPrvdr}>
                <div className="material_icon2">electrical_services</div>
                <div className="text-block">Provider</div>
                {hoveredPrvdr && <div className="prvdrLogin1">Click here if you are a business owner who wants to
                  provide service to employees, customers, or partners.</div>}
              </Link>
              {/*Provider Section End*/}

              {/*Event Owner Start*/}
              <Link to="/login" onClick={loginEventOwner} className="dappbtn1 w-inline-block" onMouseEnter={toggleHoverEvntOwn} onMouseLeave={toggleHoverEvntOwn}>
                <div className="material_icon2">key</div>
                <div className="text-block">Event Owner</div>
                {hoveredEvntOwn && <div className="evntOwnLogin1">Click here to setup an Event using the BioFi Ecosystem</div>}
              </Link>
              {/*Event Owner End*/}

              <Link to="/Learn" className="dappbtn1" onMouseEnter={toggleHoverLearn} onMouseLeave={toggleHoverLearn}>
                <div className="material_icon2">school</div>
                <div className="text-block">Learn</div>
                {hoveredLearn && <div className="exptxt1"> Click here if you want to use the BioFi Ecosystem to
                  assist in registering for events that you are
                  planning.</div> }
              </Link>
            </div>
          </div>
          <div className="div-block-2" />
        </div>
      </div>
      <Footer />
    </>
  );
}